module.exports = __webpack_public_path__ + "static/img/002.413f252.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/honor/intellectual_property/002.png
// module id = kfbz
// module chunks = 0